module.exports = __webpack_public_path__ + "static/media/Phangnga.b8e299b3.webp";